import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// @mui
import { Stack, IconButton, InputAdornment, TextField, Grid, Autocomplete, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/iconify';
import "../../../sections/auth/login/login.css"
import { toast } from 'react-toastify';
import { postData, validatePostData } from 'src/webService/webService';
import { countries } from "country-data";


// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [mail, setMail] = useState("");
  const [pwd, setPwd] = useState("");
  const [mobileNo, setMobileNo] = useState('');
  const [countryCode, setCountryCode] = useState('+91');
  const location = useLocation();
  const [route, setRoute] = useState("");
  const [response, setResponse] = useState('');
  const [otp, setOtp] = useState(Array(6).fill(''));

  const dialCodes = countries.all.map(c => ({
    dialCode: c.countryCallingCodes[0],
  }));

  const validDialCodes = dialCodes
    .filter(item => item.dialCode && item.dialCode.trim() !== '')
    .map(item => item.dialCode);

  useEffect(() => {
    // Extracting the pathname without leading slash
    setRoute(location.pathname.substring(1));
  }, [location]);

  console.log(route, 'routesssssss');


  const handleClick = () => {
    debugger
    const LoginParams = {
      username: mail.trim(),
      password: pwd.trim(),
      isWeb: true
    };


    if (route === 'login' || route === 'seller/login') {
      if (mail === "" && pwd === "") {
        toast.error("All The Fields Are Required");
      } else {

        if (route === 'seller/login') {

          postData("auth/seller/login", LoginParams, null)
            .then((res) => {
              // console.log(res.status === 200);
              console.log(res);
              debugger;

              const setSessionItem = (key, value) => {
                sessionStorage.setItem(key, value == undefined || value == null || value == 'null' ? '' : value);
              };


              switch (res.status) {
                case 200:
                  sessionStorage.setItem('Role', 'Seller',);
                  setSessionItem("UserName", res?.user?.username);
                  setSessionItem("Token", `Bearer ${res?.token}`);
                  setSessionItem("UserId", res?.user?._id);
                  setSessionItem("Name", res?.user?.name);
                  setSessionItem("Email", res?.user?.email);
                  sessionStorage.setItem('Seller_UID', res?.user?.seller_uid);
                  setSessionItem("address", res?.user?.address);
                  setSessionItem("aboutus", res?.user?.aboutus);
                  setSessionItem("city", res?.user?.city);
                  setSessionItem("state", res?.user?.state);
                  setSessionItem("country", res?.user?.country);
                  setSessionItem("pincode", res?.user?.pincode);
                  setSessionItem("facebook_link", res?.user?.facebook_link);
                  setSessionItem("instagram_link", res?.user?.instagram_link);
                  setSessionItem("intro_video", res?.user?.intro_video);
                  setSessionItem("location", res?.user?.location);
                  setSessionItem("map_location", res?.user?.map_location);
                  setSessionItem("phone", res?.user?.phone);
                  setSessionItem("phone_countrycode", res?.user?.phone_countrycode);
                  setSessionItem("profile_picture", res?.user?.profile_picture);
                  setSessionItem("twitter_link", res?.user?.twitter_link);
                  setSessionItem("website_link", res?.user?.website_link);
                  setSessionItem("whatsapp", res?.user?.whatsapp);
                  setSessionItem("whatsapp_countrycode", res?.user?.whatsapp_countrycode);
                  setSessionItem("category", res?.user?.category);
                  setSessionItem("categories", res?.user?.category_names);
                  toast.success("User logged in successfully");
                  navigate("/seller/app", { replace: true });
                  break;

                case 500:
                  toast.error("Error while logging in: Server error");
                  break;
                case 400:
                  toast.error("Incorrect Password");
                  break;
                case 404:
                  toast.error("User Not Found");
                  break;
                default:
                  console.log("Login failed");
                  // toast.error("Login failed");
                  break;
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });

        } else {
          postData("auth/user/login", LoginParams, null)
            .then((res) => {
              console.log(res.status === 200);
              console.log(res);
              debugger;

              switch (res.status) {
                case 200:
                  sessionStorage.setItem("UserName", res?.user?.username);
                  sessionStorage.setItem("Token", `Bearer ${res?.token}`);
                  sessionStorage.setItem("UserId", res?.user?.id);
                  sessionStorage.setItem("Name", res?.user?.name);
                  sessionStorage.setItem("Email", res?.user?.email);
                  sessionStorage.setItem('Role', 'Admin');
                  toast.success("User logged in successfully");
                  navigate("/admin/app", { replace: true });
                  break;

                case 500:
                  toast.error("Error while logging in: Server error");
                  break;
                case 400:
                  toast.error("Incorrect Password");
                  break;
                case 404:
                  toast.error("User Not Found");
                  break;
                default:
                  toast.error("Unexpected Error occurred");
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }

      }
    }
  };

  return (

    <>
      <Stack spacing={3}>
        <h4 className='text-center'>LOG IN</h4>
        <TextField
          className="textfield"
          name="email"
          label="Username or Email"
          value={mail}
          onChange={(e) => setMail(e.target.value)}
          autoComplete="off"
          required
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          className="textfield"
          name="password"
          label="Password"
          type={showPassword ? "text" : "password"}
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  <Iconify
                    icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <LoadingButton fullWidth size="large" type="submit" variant="contained" sx={{ my: 2 }} onClick={handleClick}>
        Login
      </LoadingButton>
      <div className='' style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
        <Link className="nav-link text-danger-0" to="/forgot-password" style={{ textAlign: 'right' }}>
          <Iconify icon="eva:alert-triangle-outline" sx={{ mr: 1 }} />  Forgot password
        </Link>
        <Link className="nav-link text-center" style={{ textAlign: 'left' }} to="/home">
          <Iconify icon="eva:arrow-circle-left-outline" sx={{ mr: 1 }} />  Back to home
        </Link>
      </div>
    </>
  );
}

